// Mock data
export const mockHomeData = {
    // Top KPIs data
    signedUpUsers: 54400,
    signedUpUsersPercentage: 20,
    activeUsersCount: 16320,
    activeUsersPercentage: 20,
    advancesFees: 391680,
    advancesFeesPercentage: 20,
    settlementsValue: 59500,
    settlementsValuePercentage: 20,
    
    // Bottom KPIs data
    directDepositSwitches: 8160,
    directDepositSwitchesPercentage: 20,
    directDepositSwitchVolume: 342720000,
    directDepositSwitchVolumePercentage: 20,
    totalAdvancesCount: 130560,
    totalAdvancesCountPercentage: 20,
    totalAdvances: 10183680,
    totalAdvancesPercentage: 20
};

export const homeConfig = {
    title: "Enrollment & Monetization",
    bottomTitle: "Deposits & Usage",
    topKPIs: [
        {
            key: 'signedUpUsers',
            title: 'Total Users Enrolled',
            percentageKey: 'signedUpUsersPercentage',
        },
        {
            key: 'activeUsersCount',
            title: 'Total Active Users',
            percentageKey: 'activeUsersPercentage',
        },
        {
            key: 'advancesFees',
            title: 'Non-Interest Income ($)',
            percentageKey: 'advancesFeesPercentage',
            isCurrency: true
        },
        {
            key: 'settlementsValue',
            title: 'Net Interest Income',
            percentageKey: 'settlementsValuePercentage',
            isCurrency: true
        }
    ],
    charts: [
        {
            title: 'Enrollment Funnel',
            type: 'enrollmentFunnel'
        },
        {
            title: 'Advances & Non-Interest Income',
            type: 'advancesAndNonInterestIncome'
        }
    ],
    bottomKPIs: [
        {
            key: 'directDepositSwitches',
            title: 'Direct Deposit Switches',
            percentageKey: 'directDepositSwitchesPercentage'
        },
        {
            key: 'directDepositSwitchVolume',
            title: 'Direct Deposit Switch Volume ($)',
            percentageKey: 'directDepositSwitchVolumePercentage',
            isCurrency: true
        },
        {
            key: 'totalAdvancesCount',
            title: 'Total Advances',
            percentageKey: 'totalAdvancesCountPercentage'
        },
        {
            key: 'totalAdvances',
            title: 'Total Advance Volume ($)',
            percentageKey: 'totalAdvancesPercentage',
            isCurrency: true
        }
    ]
};
